import styled from "styled-components";

const Style = styled.div`
  width: 90%;
  position: relative;

  animation: 0.5s minHeightAnimation forwards;

  @keyframes minHeightAnimation {
    0% {min-height: 400px;}
    100% {min-height: 0px;}
  }
`;

export default Style;
